/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import { getStore } from '../store/store';
import { OptionSubCategory } from 'owa-options-core';
import updateCategory from '../orchestrators/updateCategory';

export default orchestratorAction('selectSubcategory', async function selectSubcategory(
    subcategory: OptionSubCategory
): Promise<void> {
    const store = getStore();
    updateCategory(store.currentCategoryKey, subcategory.key, null);
});
